/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_SoonInputs */

const en_features_soon = /** @type {(inputs: Features_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

const pl_features_soon = /** @type {(inputs: Features_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wkrótce`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Features_SoonInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_soon = /** @type {((inputs?: Features_SoonInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_SoonInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_soon(inputs)
	return en_features_soon(inputs)
});